import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

/* const eliminarA = (dato) => {
  let array_final = "";
  for (let i = 0; i < dato.length; i++) {
    if (dato[i] + dato[i + 1] === "A0") {
      while (i < dato.length && dato[i] !== " ") {
        i++;
      }
    }
    array_final += dato[i];
  }
  return array_final.replace(/[,\-|]/g, "\n");
}; */

const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#000",
    height: "100%",
    paddingBottom: 70,
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  logo: {
    width: "100%",
    height: "15%",
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.1,
    zIndex: "-10",
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    marginBottom: 20,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  textBold: {
    fontWeight: 700,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 15,
    fontFamily: "Roboto",
  },
  gridItem: {
    width: "48%",
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  // Estilos para la tabla de medicamentos
  medicineTable: {
    width: "100%",
    marginTop: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  colNum: {
    width: "8%",
    padding: 5,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  colMedicine: {
    width: "32%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  colQuantity: {
    width: "20%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  colInstructions: {
    width: "40%",
    padding: 5,
  },
  headerText: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: 10,
  },
  cellText: {
    fontFamily: "Roboto",
    fontSize: 9,
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: 90,
    marginLeft: "42%",
    height: 80,
  },
});

const RecetaPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.watermark} src="/images/longLogo.png" />
        <Image style={styles.logo} src="/images/headerright.png" />
        <Text style={styles.title}>RECETARIO MÉDICO</Text>
        {/* Información del paciente */}
        // Información del paciente - Manteniendo campos originales pero con
        nueva estructura
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {data?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Diagnóstico:</Text>{" "}
              {data.diagnostico_dat}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Peso:</Text> {data.peso} kg
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Altura:</Text> {data.altura} cm
            </Text>
          </View>
        </View>
        {/* Tabla de medicamentos */}
        <View style={styles.section}>
          {/*  <Text style={styles.textBold}>Rp.</Text> */}

          <View style={styles.medicineTable}>
            {/* Encabezado de la tabla */}
            <View style={styles.tableHeader}>
              <View style={styles.colNum}>
                <Text style={styles.headerText}>#</Text>
              </View>
              <View style={styles.colMedicine}>
                <Text style={styles.headerText}>Medicamento</Text>
              </View>
              <View style={styles.colQuantity}>
                <Text style={styles.headerText}>Cantidad</Text>
              </View>
              <View style={styles.colInstructions}>
                <Text style={styles.headerText}>Instrucciones</Text>
              </View>
            </View>

            {/* Filas de medicamentos */}
            {data.recetas.map((receta, index) => (
              <View style={styles.tableRow} key={index}>
                <View style={styles.colNum}>
                  <Text style={styles.cellText}>{index + 1}.</Text>
                </View>
                <View style={styles.colMedicine}>
                  <Text style={styles.cellText}>{receta?.nombre}</Text>
                </View>
                <View style={styles.colQuantity}>
                  <Text style={styles.cellText}>
                    {receta?.cantidad} {receta?.presentacion}
                  </Text>
                </View>
                <View style={styles.colInstructions}>
                  <Text style={styles.cellText}>{receta?.instrucciones}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
        {/* Firma del médico */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default RecetaPdf;
